import gql from 'graphql-tag';
import { unityLastAccessFragment } from './fragments';

export const unityLastAccesses = gql`
  query unityLastAccesses($unityId: Int!) {
    unityLastAccesses(unityId: $unityId) {
      ...unityLastAccessParts
    }
  }
  ${unityLastAccessFragment}
`;
